import { Component, OnInit, Input } from '@angular/core';
import { EditorService } from '../../../../../bookeditoption/editor.service';
@Component({
  selector: 'app-inlineimage',
  templateUrl: './inlineimage.component.html',
  styleUrls: ['./inlineimage.component.css']
})
export class InlineimageComponent implements OnInit {
  @Input() data: any
  bookObj
  googleImageData;
  imageurl;
  showHidehgt = true;
  textImageData = "";
  inlineImageWidthVal = undefined;
  inlineImageHeightVal = undefined;
  constructor(private editorService: EditorService) { }


  ngOnInit() {
    this.bookObj = this.data.popupProps.curComp.bookObj;
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "Inline Image") {
      this.textImageData = cardData;
      this.initializeData(cardData)
    }
  }
  initializeData(data) {
    if (data.inlineImageheight) {
      this.inlineImageHeightVal = data.inlineImageheight;
    }
    if (data.inlineImagewidth) {
      this.inlineImageWidthVal = data.inlineImagewidth;
    }
    if (data.url) {
      this.imageurl = data.url;
    }
  }
  onChangeGalleryimage(img) {
    this.imageurl = img;
    var image = new Image();
    image.src = img;
    var that = this;
    image.onload = function () {
      that.inlineImageWidthVal = image.naturalWidth;
      that.inlineImageHeightVal = image.naturalHeight;
    }
    this.showHidehgt = true;
    let layer = this.editorService.getIframeReference();
    let obj: any = {
      'url': img.url,
      'width': ' ',
      'height': ' '
    }
    layer.updateTextMediaProperties(obj);
  }
  showHideWdtHgt(state) {
    if (state == "false") {
      this.showHidehgt = false;
    } else {
      this.showHidehgt = true;
    }
  }
  //For changing the width of inline image
  changeIImageWidth(evt) {
    if (evt.keyCode == 13) {
      this.changeInlineImageWidth();
    }
  }
  changeInlineImageWidth() {
    let layer = this.editorService.getIframeReference();
    this.imageurl
    let obj: any = {
      'url': this.imageurl,
      'width': this.inlineImageWidthVal,
      'height': this.inlineImageHeightVal
    }
    layer.updateTextMediaProperties(obj);
  }
  //For changing the height of inline image
  changeIImageHeight(evt) {
    if (evt.keyCode == 13) {
      this.changeInlineImageHeight();
    }
  }
  changeInlineImageHeight() {
    let layer = this.editorService.getIframeReference();
    this.imageurl
    let obj: any = {
      'url': this.imageurl,
      'width': this.inlineImageWidthVal,
      'height': this.inlineImageHeightVal
    }
    layer.updateTextMediaProperties(obj);
  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/text/media/inlineimage/inlineimage.component.ts